




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import VoerroTagsInput from '@voerro/vue-tagsinput';
import HtmlFormatter from '@/shared/services/htmlFormatter';

@Component({
	components: {
		'tags-input': VoerroTagsInput,
	}
})
export default class TagsInput extends Vue {
	@Prop() public elementId: string;
	@Prop() public placeholder: string;
	@Prop() public disabled: boolean;
	@Prop() public beforeAddingTag: () => boolean;
	@Prop() public validate: (input: string) => boolean;
	@Prop() public addTagsOnSpace: boolean;
	@Prop({default: 0}) public limit: number;
	@Prop() public value: string[]; // to support v-model fire a "input" event and have a "value" prop

	public tags: Array<{key: string, value: string}> = []; // binding to VoerroTagsInput component

	private internalList: Array<{ encoded: string, raw: string }> = []; // internal list mapping sanitized values to the original values

	@Watch('value', { immediate: true })
	public onValueChanged(values: string[], oldValues: string[]) {
		if (!values || this.arraysEqual(values, oldValues)) {
			return;
		}
		this.tags = values.map(value => ({ key: '', value }));
	}

	// gets called when someone adds a tag through the control
	// and for all values when the input is updated
	public onBeforeAddingTag(tag: {key: string, value: string}) {
		const rawValue = tag.value;
		tag.value = HtmlFormatter.escapeHtmlCharacters(rawValue);

		if (!this.internalList.find(x => x.encoded === tag.value)) {
			this.internalList.push({
				encoded: tag.value,
				raw: rawValue
			});
		}

		return true;
	}

	public onBeforeRemovingTag(tag: any) {
		this.internalList = this.internalList.filter(x => x.encoded !== tag.value);
		return true;
	}

	public onInput(tags: Array<{key: string, value: string}>) {
		// send back original values
		this.$emit('input', tags.map(x => this.getOriginalValue(x.value)));
	}

	public onTagsUpdated() {
		this.$emit('tags-updated');
	}

	public onKeyUp() {
		const tagElement = this.$refs['tag-input-element'] as any;
		this.$emit('text-updated', tagElement.input);
	}

	private getOriginalValue(value: string): string {
		const internalValue = this.internalList.find(x => x.encoded === value);
		return internalValue ? internalValue.raw : '';
	}

	// checks for genuine array equality
	// to close the v-model loop
	private arraysEqual(a: any, b: any) {
		if (a === b) {
			return true;
		}
		if (a == null || b == null) {
			return false;
		}
		if (a.length !== b.length) {
			return false;
		}
		for (let i = 0; i < a.length; ++i) {
			if (a[i] !== b[i]) {
				return false;
			}
		}
		return true;
	}
}

